import { render } from "./StatisticalEvalPatient.vue?vue&type=template&id=781685b2&scoped=true&ts=true"
import script from "./StatisticalEvalPatient.vue?vue&type=script&lang=ts"
export * from "./StatisticalEvalPatient.vue?vue&type=script&lang=ts"

import "./StatisticalEvalPatient.vue?vue&type=style&index=0&id=781685b2&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/DanhGia_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781685b2"]])

export default __exports__